/*=========================================================================================
  File Name: moduleDepartmentMutations.js
  Description: Department Module Mutations
==========================================================================================*/
import _ from "lodash";
export default {
	SET_DEPARTMENTS(state, departments) {
		state.departments = departments;
	},
	SET_DEPARTMENT_CATEGORY_SIDEBAR_STATUS(state, value) {
		state.showDepartmentCategorySidebar = value;
	},
	ADD_NEW_DEPARTMENT(state, department) {
		state.departments.push(department);
	},
	UPDATE_DEPARTMENT(state, department) {
		const idx = _.findIndex(state.departments, { id: department.id });
		if (idx !== -1) {
			Object.assign(state.departments[idx], department);
		}
	},
	DELETE_DEPARTMENT(state, department) {
		const idx = _.findIndex(state.departments, { id: department.id });
		if (idx !== -1) {
			state.departments.splice(idx, 1);
		}
	}
};
